import dayjs from 'dayjs';
import React from 'react';
import WebGrid from '../../../webgrid/src';
import type { StockInventoryItem } from '../../domain/metals';

export interface StockInventoryGridProps {
    data: StockInventoryItem[];
    loading: boolean;
    t: (key: string) => string;
}

const StockInventoryGrid: React.FC<StockInventoryGridProps> = ({ data, loading, t }) => (
    <WebGrid<StockInventoryItem>
        data={data}
        columns={[
            {
                key: 'contract_number',
                title: t('metals.contract'),
                dataIndex: 'contract_number',
            },
            {
                key: 'date',
                title: t('metals.inventoryDate'),
                dataIndex: 'date',
                render: (d: unknown) => dayjs(String(d)).format('YYYY-MM-DD'),
            },
            {
                key: 'metal_type',
                title: t('metals.metal'),
                dataIndex: 'metal_type',
            },
            {
                key: 'fineness',
                title: t('metals.karat'),
                dataIndex: 'fineness',
            },
            {
                key: 'gross_quantity',
                title: t('metals.qty'),
                dataIndex: 'gross_quantity',
            },
            {
                key: 'unit_price',
                title: t('metals.valueRon'),
                dataIndex: 'unit_price',
            },
        ]}
        loading={loading}
        pagination={false}
        onRowClick={() => {}}
        onRowDoubleClick={() => {}}
        onExport={() => {}}
        height={300}
    />
);

export default StockInventoryGrid;
